<div class="row p-t-6">
  <div class="col-12">
    <div class="row row-cols-1 row-cols-md-3 g-4">
      <div class="col m-b-3 memic-promoted-link" *ngFor="let promotedLink of promotedLinks">
        <a [href]="promotedLink.url" [attr.target]="promotedLink?.openNewTab ? '_blank' : '_self'" 
        appExternalLink (click)="onCardClick(promotedLink)">
          <div class="card memic-block memic-promoted-link">
            <div class="memic-block__pic">
              <img class="card-img-top" [src]="promotedLink.blobUrl">
            </div>
            <div class="card-body">
              <h3 class="memic-block__header">{{promotedLink.title}}</h3>
              <div class="memic-block__body">
                {{promotedLink.description}}
              </div>
            </div>
            <div class="card-footer memic-card-footer text-muted">
              <span class="memic-promoted-link__callout">
                <svg xmlns="http://www.w3.org/2000/svg" width="8" height="16" viewBox="0 0 8 16">
                  <path fill-rule="evenodd" d="M7.63 7.02L.898.287C.65.041.44-.047.264.023S0 .305 0 .657V15.18c0 .352.088.563.264.633.176.07.387-.017.634-.264L7.63 8.816c.247-.247.37-.546.37-.898s-.123-.651-.37-.898z">
                  </path>
                </svg>
              </span>
            </div>
          </div>
        </a>
      </div>
    </div>
  </div>
</div>
